import { createKumoToastManager } from '@cloudflare/kumo/components/toast'

export const appToastManager = createKumoToastManager()

export function showToast({ title, description, variant = 'info' }) {
  return appToastManager.add({
    title,
    description,
    variant,
    timeout: 5000,
  })
}

export function showSuccessToast(description, title = 'Berhasil') {
  return showToast({ title, description, variant: 'success' })
}

export function showErrorToast(description, title = 'Terjadi kesalahan') {
  return showToast({ title, description, variant: 'error' })
}
